// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"a2c79c7e7d--tooltip--qn_hc","arrow":"a2c79c7e7d--arrow--Lmc20","cross":"a2c79c7e7d--cross--c8HDB"};